import * as React from "react";
import { Box, Text, Flex, Layout, useLocalVariant, BackForwardControls } from "@draftkings/arena-web";
import { Status } from "./Status";
import { Combination } from "./Combination";
import { Separator } from "../Separator";
import { SportsbookContext } from "../../contexts";
export const CombinationsList = React.memo(function Combinations(props) {
    const { purchaseId, combinations, statuses, combinationsPerPage, } = props;
    const { dictionary } = React.useContext(SportsbookContext);
    const maxPage = Math.ceil(combinations.length / combinationsPerPage);
    const [page, setPage] = React.useState(1);
    const showPagination = maxPage > 1;
    const combinationList = useLocalVariant("layout", {
        $extendFromVariant: "borderedCard",
        root: {
            marginTop: "$s3",
            paddingTop: "$s2",
            paddingRight: "$s2",
            paddingBottom: "12px",
            paddingLeft: "$s2",
        }
    });
    const combinationBetsHeadlineVariant = useLocalVariant("text", {
        $extendFromVariant: "betHeadline",
        root: {
            flex: "1 1 auto",
        }
    });
    const start = (page - 1) * combinationsPerPage;
    const end = start + combinationsPerPage > combinations.length ? combinations.length : start + combinationsPerPage;
    const combinationsToShow = showPagination ? combinations.slice(start, end) : combinations;
    const moveOnPage = (page) => () => setPage(page);
    return (React.createElement(Layout, { variant: combinationList, testId: 'combination-list' },
        React.createElement(Flex, null,
            React.createElement(Text, { testId: "combination-bets-title-text", variant: combinationBetsHeadlineVariant }, dictionary.myBetsDictionary.Bets),
            React.createElement(Text, { testId: "combination-bets-to-pay-text", variant: "betHeadline" }, dictionary.myBetsDictionary.ToPay)),
        React.createElement(Separator, { space: "12px" }),
        React.createElement(Box, { as: "ul", margin: 0, padding: 0, testId: 'combinations' },
            combinationsToShow.map(combination => React.createElement(Combination, Object.assign({ key: combination.id }, combination))),
            showPagination && React.createElement(BackForwardControls, { testId: `pagination-${purchaseId}`, variant: "pagination", backDisabled: page === 1, onBackClick: moveOnPage(page - 1), forwardDisabled: page === maxPage, onForwardClick: moveOnPage(page + 1) },
                React.createElement(Box, { flex: "1 1 auto", lineHeight: "24px" }, `${page} ${dictionary.myBetsDictionary.CombinationPaginationText} ${maxPage}`))),
        React.createElement(Box, null, statuses.map(statusEntity => React.createElement(Status, { key: `${statusEntity.name}`, statusEntity: statusEntity })))));
});
//# sourceMappingURL=CombinationsList.js.map